import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { environment } from 'src/config/environment';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';
import { ExtraErrorData as ExtraErrorDataIntegration } from '@sentry/integrations';
import { WebSdkProvider } from 'src/webSdk/WebSdkProvider';
import {
  WebSdkInitOptions,
  WebSdkEventHandlers,
} from 'src/webSdk/models/webSdk';
import { handleNodeChildError } from 'src/handleNodeChildError';
import { WebSdkBuilder } from 'src/webSdk';

export const renderApp = (
  initOptions?: WebSdkInitOptions,
  eventHandlers?: WebSdkEventHandlers
) => {
  handleNodeChildError();
  console.log(`AIS app v.${process.env.REACT_APP_VERSION}`);

  Sentry.init({
    allowUrls: environment.sentryAllowedUrls ?? undefined,
    dsn: environment.sentryDsn,
    environment: `${environment.environmentType}${
      environment.isWebSdk ? '-SDK' : ''
    }`,
    integrations: [
      new Sentry.BrowserTracing(),
      new ExtraErrorDataIntegration({
        depth: 10,
      }),
    ],
    normalizeDepth: 10,
    // Performance Monitoring
    tracesSampleRate: environment.sentryTracesSampleRate,
  });

  return environment.isWebSdk ? (
    <WebSdkProvider initOptions={initOptions} eventHandlers={eventHandlers}>
      <App />
    </WebSdkProvider>
  ) : (
    <App />
  );
};

if (!environment.isWebSdk) {
  environment.gtmId && TagManager.initialize({ gtmId: environment.gtmId });
  const root = createRoot(document.getElementById('root')!);
  root.render(renderApp());
}

export const init = (initOptions: WebSdkInitOptions) => {
  localStorage.setItem('verificationId', initOptions.verificationId);
  return new WebSdkBuilder(initOptions);
};
